import React from 'react';
import Skeleton from 'react-loading-skeleton';

const AvailableRoomsLoading = () => {
  return (
    <div className="rounded mb-30">
      <Skeleton width="100%" height={60} />

      <div className={`bg-blue-2 px-30 py-30 sm:px-20 sm:py-20 border-bottom-light`}>
        <div className="row y-gap-30">
          <div className="col-xl-3 col-xxl-2 col-md-12 ">
            <div className="pb-10">
              <div className="fw-500 text-18">
                <Skeleton width={70} height={40} />
              </div>
              <div className="text-14 fw-500 xs:d-none md:d-none  text-blue-1 link-with-hover">&nbsp;</div>
            </div>
            <div className=" col-12 col-md-4 col-xl-12 mt-10 ">
              <Skeleton width="100%" height={200} />
            </div>
            {/* image */}

            <div>
              <div className="y-gap-5 mt-20">
                <div className="d-flex items-center">
                  <div className="text-15">
                    <Skeleton width={100} />
                  </div>
                </div>
                <div className="d-flex items-center">
                  <Skeleton width={20} height={20} className=" text-20 mr-10" />
                  <div className="text-15">
                    <Skeleton width={100} />
                  </div>
                </div>
                <button className="d-block text-14 fw-500 text-blue-1">
                  <Skeleton width={150} />
                </button>
              </div>
            </div>
          </div>

          <div className="col-xl-9 col-xxl-10 col-md-12">
            <div className="row ">
              <div className="pb-10 col">
                <div className="fw-500 text-18">
                  <Skeleton width={200} height={40} />
                </div>
                <div className=" d-flex items-center">
                  <Skeleton width={250} height={30} />
                </div>
              </div>
              <div className="col-auto">
                <Skeleton width={120} height={40} />
              </div>
            </div>
            <Skeleton className={`bg-white rounded-4 px-30 py-20 mt-10`} width="100%" height={100} />
            <Skeleton className={`bg-white rounded-4 px-30 py-20 mt-10`} width="100%" height={100} />
            <Skeleton className={`bg-white rounded-4 px-30 py-20 mt-10`} width="100%" height={100} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvailableRoomsLoading;
